import { render, staticRenderFns } from "./sms-config.vue?vue&type=template&id=4d258fd5&"
import script from "./sms-config.vue?vue&type=script&lang=js&"
export * from "./sms-config.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports